module.exports = __webpack_public_path__ + "img/Reunião em comunidades produtoras de macieira 1.b6f6dafe.webp";